import React from "react";

import { Icon, Tooltip } from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";

// Ícone de ajuda (hint) para usar ao lado de um texto, no meio da linha. O
// ícone é focável (tabIndex) para o hint também abrir por toque/teclado.
// `inline-flex` sobrescreve o `display: flex` global de .hint-tooltip, que
// jogaria o ícone para a linha de baixo.
export default function HintIcone({ hint, rotulo }) {
  if (!hint) return null;

  return (
    <Tooltip label={hint} fontSize="md" maxW="400px" textAlign="justify">
      <span
        className="hint-tooltip"
        tabIndex={0}
        aria-label={`Ajuda: ${rotulo}`}
        style={{
          display: "inline-flex",
          marginLeft: "4px",
          verticalAlign: "middle",
        }}
      >
        <Icon as={IoHelpCircle} color="#6B6C71" boxSize="18px" />
      </span>
    </Tooltip>
  );
}
